import { render, staticRenderFns } from "./deviceList.vue?vue&type=template&id=964a353c&scoped=true&xmlns=true"
import script from "./deviceList.vue?vue&type=script&lang=js"
export * from "./deviceList.vue?vue&type=script&lang=js"
import style0 from "./deviceList.vue?vue&type=style&index=0&id=964a353c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964a353c",
  null
  
)

export default component.exports